import script from "./Bar.vue?vue&type=script&setup=true&lang=js"
export * from "./Bar.vue?vue&type=script&setup=true&lang=js"

import "./Bar.vue?vue&type=style&index=0&id=266a4138&lang=css"

const __exports__ = script;

export default __exports__